import React from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";

const SuccessScreen = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = () => {
    navigate("/auth/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f7fa",
        p: 2,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ duration: 0.5 }}
        style={{ width: "100%", maxWidth: 450 }}
      >
        <Card
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 24px 64px rgba(0,0,0,0.15)",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #003d38 0%, #00786F 100%)",
              color: "white",
              textAlign: "center",
            }}
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              <Box
                sx={{
                  backgroundColor: "rgba(255,215,0,0.15)",
                  borderRadius: "50%",
                  padding: "16px",
                  display: "inline-block",
                  mb: 2,
                  border: "2px solid rgba(255,215,0,0.2)",
                }}
              >
                <CheckIcon sx={{ fontSize: 48, color: "#FFD700" }} />
              </Box>
            </motion.div>

            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Password Reset Successful
            </Typography>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 3,
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="body1" color="text.secondary">
                  Your password has been successfully reset. You can now log in
                  with your new password.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleClick}
                  fullWidth
                  sx={{
                    backgroundColor: "#00786F",
                    color: "#fff",
                    fontWeight: 600,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: "none",
                    fontSize: "1rem",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                    transition:
                      "transform 0.2s ease-in-out, background-color 0.2s ease",
                  }}
                >
                  Continue to Login
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </motion.div>
    </Box>
  );
};

export default SuccessScreen;
